/**
 * Landing directly on a URL with a #anchor scrolls to it once, on initial layout - before web
 * fonts have swapped in. The fallback font renders wider (see fonts.scss), which can wrap the
 * header nav onto a second line and make it taller than the fixed --site-header-height CSS
 * assumes, so the anchor's scroll-margin-top under-compensates and the target ends up partly
 * behind the header. Once fonts settle, re-run the scroll so it lands in the right place.
 */
export function initAnchorScroll(): void {
    if(!location.hash) {
        return;
    }

    if(!("fonts" in document)) {
        return;
    }

    document.fonts.ready.then(() => {
        const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));

        target?.scrollIntoView();
    });
}
